<script lang="ts">
  import { CircleHelp } from "lucide-svelte";
</script>

<span class="unknown-vessel-badge" aria-hidden="true">
  <CircleHelp size={18} strokeWidth={2.2} />
</span>
